export default {
  cancelText: 'ÐÑÐ¼ÐµÐ½Ð°'
};
